import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

const COPY = {
  confirm: { busy: "Confirming your subscription…", ok: "You're subscribed.", okText: (e) => `We'll email ${e} whenever a new article is published.` },
  unsubscribe: { busy: "Unsubscribing…", ok: "You've been unsubscribed.", okText: (e) => `${e} won't receive any more emails from ukdiscovered.` },
};

export default function NewsletterAction({ action }) {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "busy" });
  const copy = COPY[action];

  useEffect(() => {
    api.post(`/newsletter/${action}`, { token: params.get("token") || "" })
      .then((r) => setState({ status: "ok", email: r.data.email }))
      .catch((e) => setState({ status: "error", error: formatApiError(e) }));
  }, [action, params]);

  return (
    <div className="max-w-2xl mx-auto pt-20 fade-up" data-testid={`newsletter-${action}-page`}>
      <p className="meta">Newsletter</p>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight" data-testid={`newsletter-${action}-status`}>
        {state.status === "busy" ? copy.busy : state.status === "ok" ? copy.ok : "Something went wrong."}
      </h1>
      <p className="mt-5 text-lg text-[var(--ink-2)]">{state.status === "ok" ? copy.okText(state.email) : state.error}</p>
      <Link to="/" className="mt-8 inline-block font-ui text-sm link-quiet underline underline-offset-4" data-testid="newsletter-home-link">Go to the front page</Link>
    </div>
  );
}
